export const Section = ({
  children,
  sectionSpacingSize,
  sectionSpacing,
  contentSize = 'sl',
  additionalClass = '',
  id = '',
}) => {
  let spacingSize = 'm'

  switch (sectionSpacingSize) {
    case '1':
      spacingSize = 's'
      break
    case '2':
      spacingSize = 'm'
      break
    case '3':
      spacingSize = 'l'
      break
    default:
      break
  }

  let spacingTop = true
  let spacingBottom = true

  switch (sectionSpacing) {
    case 'DefaultSpacing':
      break
    case '1':
      spacingTop = false
      spacingBottom = false
      break
    case '2':
      spacingBottom = false
      break
    case '3':
      spacingTop = false
      break
    default:
      break
  }

  const classNames = [
    'section-container',
    spacingTop ? `spacing-above-${spacingSize}` : 'spacing-above-remove',
    spacingBottom ? `spacing-below-${spacingSize}` : 'spacing-below-remove',
    additionalClass,
  ].join(' ')

  return (
    <section className={classNames}>
      <div className="anchor-target" {...(id ? { id } : {})} />
      <div className={`content-size-${contentSize}`}>{children}</div>
    </section>
  )
}
